var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosNodejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 89,
    viewBox: "0 0 115 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_14)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8509 88.7436C56.4617 88.7436 56.0982 88.6127 55.7606 88.3834L52.3082 85.7956C51.7889 85.435 52.0485 85.3041 52.2044 85.2386C52.9052 84.9438 53.035 84.8781 53.7618 84.3543C53.8398 84.2885 53.9438 84.3214 54.0215 84.3869L56.6694 86.3851C56.7732 86.4506 56.903 86.4506 56.9807 86.3851L67.3386 78.8179C67.4424 78.7524 67.4945 78.6211 67.4945 78.4576V63.3559C67.4945 63.1918 67.4424 63.0612 67.3386 62.9954L56.9807 55.461C56.877 55.3953 56.7471 55.3953 56.6694 55.461L46.3115 62.9954C46.2078 63.0609 46.1557 63.2247 46.1557 63.3557V78.4573C46.1557 78.5886 46.2078 78.7521 46.3115 78.8179L49.1412 80.8816C50.6728 81.8643 51.6332 80.7177 51.6332 79.5712V64.666C51.6332 64.4696 51.763 64.2729 51.9448 64.2729H53.2686C53.4245 64.2729 53.5801 64.4367 53.5801 64.666V79.5712C53.5801 82.159 52.4638 83.6661 50.5169 83.6661C49.9199 83.6661 49.4527 83.6661 48.1286 82.8469L45.403 80.8816C44.728 80.3904 44.3127 79.4729 44.3127 78.4902V63.3885C44.3127 62.4059 44.728 61.4884 45.403 60.9972L55.7606 53.4299C56.4098 52.9713 57.2925 52.9713 57.9414 53.4299L68.299 60.9972C68.974 61.4884 69.3895 62.4059 69.3895 63.3885V78.4902C69.3895 79.4729 68.974 80.3904 68.299 80.8816L57.9414 88.4488C57.6038 88.6455 57.2143 88.7436 56.8509 88.7436ZM60.044 78.3592C55.5012 78.3592 54.5666 75.7386 54.5666 73.511C54.5666 73.3143 54.6964 73.1179 54.8782 73.1179H56.2281C56.3837 73.1179 56.5135 73.2488 56.5135 73.4455C56.7213 75.1816 57.3183 76.0333 60.07 76.0333C62.2505 76.0333 63.1853 75.4109 63.1853 73.9367C63.1853 73.085 62.9255 72.4629 59.5249 72.0368C56.6953 71.6763 54.93 70.8903 54.93 68.0403C54.93 65.3868 56.6955 63.8143 59.6547 63.8143C62.9774 63.8143 64.613 65.2558 64.8207 68.4003C64.8207 68.499 64.7947 68.597 64.7428 68.6954C64.6907 68.7609 64.613 68.8263 64.535 68.8263H63.1851C63.0553 68.8263 62.9255 68.6954 62.8996 68.5315C62.5881 66.73 61.7833 66.1402 59.6547 66.1402C57.2664 66.1402 56.9807 67.1886 56.9807 67.9746C56.9807 68.9247 57.3183 69.2195 60.5372 69.7435C63.7302 70.2679 65.236 71.0213 65.236 73.8384C65.21 76.7212 63.341 78.3592 60.044 78.3592Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7133 29.6796C24.7133 29.09 24.4536 28.5328 24.0383 28.238L13.0316 20.245C12.8497 20.1138 12.6421 20.0483 12.4346 20.0154H12.3306C12.123 20.0154 11.9153 20.1138 11.7336 20.245L0.72683 28.238C0.311303 28.5328 0.0518799 29.0897 0.0518799 29.6796L0.0779345 51.1691C0.0779345 51.4639 0.207759 51.7587 0.415297 51.8899C0.623061 52.0537 0.882484 52.0537 1.06442 51.8899L7.60616 47.1726C8.02146 46.8778 8.28111 46.3209 8.28111 45.7313V35.6743C8.28111 35.0848 8.54053 34.5278 8.95606 34.233L11.7336 32.2019C11.9413 32.0381 12.1749 31.9723 12.4085 31.9723C12.6421 31.9723 12.8757 32.0381 13.0576 32.2019L15.8352 34.233C16.2507 34.5278 16.5101 35.0845 16.5101 35.6743V45.7313C16.5101 46.3209 16.7698 46.8778 17.1851 47.1726L23.7268 51.8899C23.8279 51.9702 23.9449 52.0128 24.0643 52.0128C24.1837 52.0128 24.3007 51.9702 24.4018 51.8899C24.6095 51.7587 24.7393 51.4639 24.7393 51.1691L24.7133 29.6796ZM77.6184 0.0984244C77.4109 -0.0328081 77.1512 -0.0328081 76.9693 0.0984244C76.7617 0.262252 76.6319 0.52415 76.6319 0.818928V22.1123C76.6319 22.3087 76.5542 22.5052 76.3983 22.6364C76.2427 22.7345 76.0868 22.7345 75.9311 22.6364L73.1794 20.6382C72.9777 20.4932 72.7496 20.417 72.5174 20.417C72.2853 20.417 72.0571 20.4932 71.8554 20.6382L60.8486 28.664C60.4333 28.9588 60.1737 29.5158 60.1737 30.1053V46.1242C60.1737 46.7137 60.4333 47.271 60.8486 47.5657L71.8554 55.5916C72.0571 55.7366 72.2853 55.8128 72.5174 55.8128C72.7496 55.8128 72.9777 55.7366 73.1794 55.5916L84.1862 47.5657C84.6015 47.271 84.8611 46.714 84.8611 46.1242V6.19152C84.8611 5.56909 84.6015 5.01241 84.1862 4.71735L77.6184 0.0984244ZM76.6061 40.8502C76.6061 41.014 76.5542 41.145 76.4502 41.2105L72.6862 43.9621C72.6336 43.9945 72.5759 44.0113 72.5174 44.0113C72.4589 44.0113 72.4012 43.9945 72.3486 43.9621L68.5846 41.2105C68.4806 41.145 68.4287 40.9812 68.4287 40.8502V35.3467C68.4287 35.1828 68.4806 35.0519 68.5846 34.9864L72.3486 32.2345C72.4012 32.2021 72.4589 32.1853 72.5174 32.1853C72.5759 32.1853 72.6336 32.2021 72.6862 32.2345L76.4502 34.9864C76.5542 35.0516 76.6061 35.2157 76.6061 35.3467V40.8502ZM114.247 35.2157C114.663 34.921 114.896 34.364 114.896 33.7742V29.876C114.896 29.2865 114.636 28.7295 114.247 28.4347L103.318 20.4417C103.116 20.2968 102.888 20.2206 102.656 20.2206C102.424 20.2206 102.196 20.2968 101.994 20.4417L90.9874 28.4673C90.5718 28.7621 90.3124 29.3191 90.3124 29.9086V45.9278C90.3124 46.5173 90.5721 47.0743 90.9874 47.369L101.916 55.2311C102.332 55.5259 102.825 55.5259 103.214 55.2311L109.834 50.5798C110.042 50.4486 110.171 50.1538 110.171 49.8591C110.171 49.5643 110.042 49.2695 109.834 49.1383L98.7752 41.1124C98.5675 40.9486 98.4376 40.6867 98.4376 40.3919V35.3798C98.4376 35.0851 98.5675 34.7903 98.7752 34.6591L102.228 32.1693C102.329 32.0891 102.446 32.0465 102.565 32.0465C102.685 32.0465 102.802 32.0891 102.903 32.1693L106.355 34.6591C106.563 34.8229 106.693 35.0848 106.693 35.3798V39.3109C106.693 39.6056 106.823 39.9004 107.03 40.0314C107.131 40.1117 107.248 40.1543 107.368 40.1543C107.487 40.1543 107.604 40.1117 107.705 40.0314L114.247 35.2157Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.488 34.4622C102.526 34.4302 102.571 34.4131 102.617 34.4131C102.663 34.4131 102.709 34.4302 102.747 34.4622L104.85 36.0019C104.928 36.0676 104.98 36.1657 104.98 36.2967V39.3762C104.98 39.5072 104.928 39.6055 104.85 39.671L102.747 41.2106C102.709 41.2427 102.663 41.2598 102.617 41.2598C102.571 41.2598 102.526 41.2427 102.488 41.2106L100.385 39.671C100.307 39.6055 100.255 39.5072 100.255 39.3762V36.2969C100.255 36.1657 100.307 36.0674 100.385 36.0022L102.488 34.4622Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1185 20.5072C42.9167 20.3623 42.6886 20.2861 42.4565 20.2861C42.2244 20.2861 41.9963 20.3623 41.7946 20.5072L30.8658 28.4671C30.4503 28.7618 30.2167 29.3188 30.2167 29.9083V45.862C30.2167 46.4516 30.4763 47.0085 30.8658 47.3033L41.7946 55.2637C41.9963 55.4086 42.2244 55.4848 42.4565 55.4848C42.6886 55.4848 42.9167 55.4086 43.1185 55.2637L54.0475 47.3033C54.4628 47.0085 54.6966 46.4516 54.6966 45.862V29.9086C54.6966 29.3191 54.4367 28.7621 54.0475 28.4673L43.1185 20.5072Z",
    fill: "url(#paint0_linear_53_14)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 20,
    width: 25,
    height: 36
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1185 20.5072C42.9167 20.3623 42.6886 20.2861 42.4565 20.2861C42.2244 20.2861 41.9963 20.3623 41.7946 20.5072L30.8658 28.4671C30.4503 28.7618 30.2167 29.3188 30.2167 29.9083V45.862C30.2167 46.4516 30.4763 47.0085 30.8658 47.3033L41.7946 55.2637C41.9963 55.4086 42.2244 55.4848 42.4565 55.4848C42.6886 55.4848 42.9167 55.4086 43.1185 55.2637L54.0475 47.3033C54.4628 47.0085 54.6966 46.4516 54.6966 45.862V29.9086C54.6966 29.3191 54.4367 28.7621 54.0475 28.4673L43.1185 20.5072Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0734 28.4672L43.0927 20.5071C42.9848 20.4383 42.8717 20.3834 42.7551 20.3433L30.4503 46.9435C30.5522 47.1005 30.6753 47.2336 30.814 47.3366L41.7947 55.297C42.1062 55.5263 42.4696 55.5918 42.807 55.4606L54.3591 28.7951C54.2811 28.6642 54.1771 28.5653 54.0734 28.4672Z",
    fill: "url(#paint1_linear_53_14)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_53_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 20,
    width: 25,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1185 20.5072C42.9167 20.3623 42.6886 20.2861 42.4565 20.2861C42.2244 20.2861 41.9963 20.3623 41.7946 20.5072L30.8658 28.4671C30.4503 28.7618 30.2167 29.3188 30.2167 29.9083V45.862C30.2167 46.4516 30.4763 47.0085 30.8658 47.3033L41.7946 55.2637C41.9963 55.4086 42.2244 55.4848 42.4565 55.4848C42.6886 55.4848 42.9167 55.4086 43.1185 55.2637L54.0475 47.3033C54.4628 47.0085 54.6966 46.4516 54.6966 45.862V29.9086C54.6966 29.3191 54.4367 28.7621 54.0475 28.4673L43.1185 20.5072Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_53_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0994 47.3037C54.4109 47.0743 54.6445 46.6812 54.7485 46.2555L42.703 20.3106C42.3914 20.2451 42.0538 20.2777 41.7686 20.507L30.8656 28.4348L42.625 55.4934C42.796 55.458 42.9621 55.3919 43.1183 55.2969L54.0992 47.3039L54.0994 47.3037Z",
    fill: "url(#paint2_linear_53_14)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0994 47.3032L43.1445 55.2636C42.9898 55.3631 42.8231 55.4295 42.6512 55.46L42.859 55.9515L55.0079 47.0742V46.8775L54.6964 46.2222C54.6445 46.6808 54.4109 47.0739 54.0994 47.3032Z",
    fill: "url(#paint3_linear_53_14)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0994 47.3032L43.1445 55.2636C42.9898 55.3631 42.8231 55.4295 42.6512 55.46L42.859 55.9515L55.0079 47.0742V46.8775L54.6964 46.2222C54.6445 46.6808 54.4109 47.0739 54.0994 47.3032Z",
    fill: "url(#paint4_linear_53_14)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_14",
    x1: 1699.45,
    y1: 635.805,
    x2: 70.1199,
    y2: 2664.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_14",
    x1: 1065.15,
    y1: 1961.42,
    x2: 4343.19,
    y2: 550.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_14",
    x1: -73.9565,
    y1: 1780.8,
    x2: 2454.96,
    y2: 1780.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_14",
    x1: -1240.72,
    y1: 535.365,
    x2: 1288.16,
    y2: 535.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53_14",
    x1: 1656.59,
    y1: -2007.34,
    x2: 657.17,
    y2: 2142.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 89,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosNodejs);
export default __webpack_public_path__ + "static/media/logos_nodejs.cc1a768adf7cf09e990e9720cdeec142.svg";
export { ForwardRef as ReactComponent };